// extracted by mini-css-extract-plugin
module.exports = {"grid":"styles_grid__1QPCO","column":"styles_column__m8LQL"};